import React from 'react';

import { ReactComponent as SpotifyLogo } from '../../assets/logos/spotify-logo-green.svg';

const Logo = () => (<SpotifyLogo className="spotify-brand" data-testid="logo" />)

export default Logo;
